/**
 * Hangman Game Engine
 */
import { getRandomWord } from './words.js';

export const MAX_STRIKES = 6;

export class HangmanEngine {
  constructor(category = 'animals', difficulty = 'medium', customWord = null) {
    this.category = category;
    this.difficulty = difficulty;
    this.reset(customWord);
  }

  reset(customWord = null) {
    if (customWord) {
      this.word = customWord.toUpperCase();
      this.categoryName = 'Duel Challenge';
    } else {
      const selected = getRandomWord(this.category, this.difficulty);
      this.word = selected.word;
      this.categoryName = selected.category;
    }

    this.guessedLetters = new Set();
    this.strikes = 0;
    this.isWon = false;
    this.isLost = false;
  }

  guessLetter(letter) {
    const char = letter.toUpperCase();
    if (this.isWon || this.isLost) return null;
    if (this.guessedLetters.has(char)) {
      return { duplicate: true };
    }

    this.guessedLetters.add(char);
    const inWord = this.word.includes(char);

    if (!inWord) {
      this.strikes++;
      if (this.strikes >= MAX_STRIKES) {
        this.isLost = true;
      }
    } else {
      // Check win
      const allRevealed = this.word.split('').every((c) => this.guessedLetters.has(c));
      if (allRevealed) {
        this.isWon = true;
      }
    }

    return {
      letter: char,
      inWord,
      strikes: this.strikes,
      isWon: this.isWon,
      isLost: this.isLost,
      maskedWord: this.getMaskedWord()
    };
  }

  getMaskedWord() {
    return this.word
      .split('')
      .map((c) => (this.guessedLetters.has(c) ? c : '_'));
  }

  getLettersRevealedCount() {
    return this.word.split('').filter((c) => this.guessedLetters.has(c)).length;
  }

  serialize() {
    return {
      word: this.word,
      category: this.category,
      categoryName: this.categoryName,
      difficulty: this.difficulty,
      guessedLetters: Array.from(this.guessedLetters),
      strikes: this.strikes,
      isWon: this.isWon,
      isLost: this.isLost
    };
  }

  restore(data) {
    if (!data) return;
    this.word = data.word;
    this.category = data.category;
    this.categoryName = data.categoryName;
    this.difficulty = data.difficulty;
    this.guessedLetters = new Set(data.guessedLetters || []);
    this.strikes = data.strikes || 0;
    this.isWon = !!data.isWon;
    this.isLost = !!data.isLost;
  }
}
